import {
  type FC,
  useCallback,
} from 'react';
import React from 'react';
import { useDispatch } from 'react-redux';
import { isModalTypeWithProps } from '~/modal/isModalTypeWithProps';
import { modalRenderer } from '~/modal/modalRendererRegistry';
import { closeModal } from '~/store/modal/modal.actionCreators';
import { useModalStackSelector } from '~/store/modal/modal.selectors';

/***
 * Don't use this component. It should be rendered once in the app.
 */
export const AppModalRendererContainer: FC = () => {
  const dispatch = useDispatch();
  const modalStack = useModalStackSelector();
  const openedModal = modalStack[modalStack.length - 1];

  const onClose = useCallback((id: string) => {
    const modal = modalStack.find(modal => modal.id === id);

    if (!modal) {
      return;
    }

    const onClose = isModalTypeWithProps(modal.typeWithArgs) ? modal.typeWithArgs.modalProps?.onClose : (modal.typeWithArgs as any)?.[1]?.onClose;
    onClose?.();

    return dispatch(closeModal(id));
  }, [dispatch, modalStack]);

  if (!openedModal) {
    return null;
  }

  return (
    <>
      {modalStack.map(modal => {
        if (isModalTypeWithProps(modal.typeWithArgs)) {
          const { modalType, modalProps } = modal.typeWithArgs;
          return modalRenderer.render(modalType, {
            ...modalProps,
            onClose: () => onClose(modal.id),
            isOpen: modal === openedModal,
          } as any,
          modal.id);
        }

        console.error('Unknown modal type: ', modal.typeWithArgs);

        return null;
      })}
    </>
  );
};
